import React, { useEffect, useState } from 'react';
import Typography from '../../../components/Typography/Typography';
import Table from '../../../components/Table/Table';
import { useLoader } from '../../../hooks';
import { toast } from 'react-toastify';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';
import { UilSync, UilInfoCircle, UilQuestionCircle } from '@iconscout/react-unicons';
import { DropdownComponent, ToggleButtonWithState } from '../../../components/Inputs/Input';
import _ from 'lodash';
import { momentTimeFormater } from '../../../utils/timeHelper';
import ModalComponent from '../../../components/ModalComponent/ModalComponent';
import MFRRActivationSignalViewer from './ModalComponent/MFRRActivationSignalViewer';

import classes from '../../../styles/AllDevices.module.css';
import FRRClasses from '../index.module.css';
import { MFRRService } from '../../../services/MFRRService';

function RedisCurrent({ area, cId, }) {
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);
    const [seconds, setSeconds] = useState(10);
    const [isAutoRefresh, setIsAutorefresh] = useState(false);
    const [counterInterval, setCounterInterval] = useState(null);
    const [signalViewerModal, setSignalViewerModal] = useState({ status: false, data: null });

    useEffect(() => {
        getRedisCurrentData();
    }, []);

    const getRedisCurrentData = (showLoader = true) => {
        const params = {
            area
        };
        MFRRService.GetRedisCurrentData(params, showLoader ? startLoader : () => { }, handleRedisDataSuccess, handleError, showLoader ? stopLoader : () => { });
    };

    const handleRedisDataSuccess = ({ data }) => {
        const tempData = data?.data?.map((item) => ({
            customerName: item.customerName,
            edgeId: item.edgeId,
            edgeAlias: item.edgeAlias,
            instanceName: item.instanceName,
            askedAndCurrentPower: `${_.get(item, 'maxAskedPower', '--')} / ${_.get(item, 'currentCapacity', '--')}`,
            response: _.get(item, 'response', '--'),
            responseStatus: _.get(item, 'responseStatus', '--'),
            activationStatus: (
                <div className={`${FRRClasses.ProfileIconContainer} ${FRRClasses.StatusOngoing}`} >
                    Ongoing
                </div>
            ),
            startTime: momentTimeFormater(item.startTime).format('YYYY-MM-DD HH:mm:ss'),
            endTime: momentTimeFormater(item.endTime).format('YYYY-MM-DD HH:mm:ss'),
            info: (
                <div onClick={() => setSignalViewerModal({ status: true, data: item })}>
                    <CustomTooltip content={'Signal Viewer'}>
                        <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                    </CustomTooltip>
                </div>
            ),
        }));
        setData(tempData);
    };

    const handleError = (err) => {
        toast.error(err?.response?.data?.message);
    };

    useEffect(() => {
        if (isAutoRefresh) {
            const interval = setInterval(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                } else {
                    getRedisCurrentData(false);
                    setSeconds(10);
                }
            }, 1000);
            setCounterInterval(interval);
            return () => clearInterval(interval);
        }
    }, [isAutoRefresh, seconds]);

    return (
        <div>
            <div className={classes.AllDevices}>
                <div className={FRRClasses.OuterContainer}>
                    <div className={FRRClasses.FilterContainer}>
                        <Typography content="Redis Current" />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={data.length || 0} />
                            </span>
                        </div>
                    </div>
                    <div className={FRRClasses.FilterContainer}>
                        <div className={FRRClasses.RefreshContainer}>
                            <div>
                                <CustomTooltip content={'Refresh'}>
                                    <div>
                                        <UilSync
                                            size={'1.5vw'}
                                            style={{
                                                cursor: 'pointer',
                                                marginTop: '0.4vw',
                                                color: 'var(--color-primary)',
                                            }}
                                            onClick={() => {
                                                getRedisCurrentData();
                                            }}
                                        />
                                    </div>
                                </CustomTooltip>
                            </div>
                            <div className={FRRClasses.TimerContainer}>
                                <ToggleButtonWithState
                                    label={'Auto Refresh'}
                                    value={isAutoRefresh}
                                    style={{ marginTop: '0' }}
                                    onChange={(e) => {
                                        setIsAutorefresh(e.target.checked);
                                        clearInterval(counterInterval);
                                        setSeconds(10);
                                    }}
                                />
                                {isAutoRefresh && <label className={FRRClasses.TimerLabel}>in {seconds} seconds</label>}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Table
                        head={[
                            'Customer Name',
                            'Edge ID',
                            'Edge Alias',
                            'Instance Name',
                            'Ask. Power / Cur. Power',
                            'Act.Status',
                            (<div >
                                <CustomTooltip content={'Response to energinet mentioning our system will activate or will be unavailable.'}>
                                    <div style={{ display: 'flex' }}>
                                        <div>Response</div>
                                        <UilQuestionCircle size="1vw" />
                                    </div>
                                </CustomTooltip>
                            </div>),
                            (<div>
                                <CustomTooltip content={'Status of the response sent to energinet acknowledging the received command.'}>
                                    <div style={{ display: 'flex' }}>
                                        <div>Response Status</div>
                                        <UilQuestionCircle size="1vw" />
                                    </div>
                                </CustomTooltip>
                            </div>),
                            'Start Time (CET)',
                            'End Time (CET)',
                            'Info'
                        ]}
                        keys={[
                            'customerName',
                            'edgeId',
                            'edgeAlias',
                            'instanceName',
                            'askedAndCurrentPower',
                            'activationStatus',
                            'response',
                            'responseStatus',
                            'startTime',
                            'endTime',
                            'info'
                        ]}
                        data={
                            data
                        }
                    />
                </div>
            </div>

            <ModalComponent
                isOpen={signalViewerModal.status}
                setOpen={(status) => {
                    setSignalViewerModal({ status: false, data: '' });
                }}
            >
                <MFRRActivationSignalViewer
                    setOpen={setSignalViewerModal}
                    data={signalViewerModal.data}
                />
            </ModalComponent>
        </div>
    );
}

export default RedisCurrent;
